// "Repetir último pedido" y "Volver a pedir": cargan el carrito con lo de un pedido anterior. Si ya había algo en el
// carrito, pregunta si sumarlo o empezar de nuevo. El carrito revisa precios y stock y avisa qué cambió.
import { HojaInferior } from '@reparto/ui';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { cargarVarios, carritoVacio, type DatosArticulo } from '../datos/carrito';
import { cambiarCarrito, useCarrito } from '../datos/estado-carrito';
import { Boton } from './base';

export type ItemRepetir = DatosArticulo & { bultos: number };

/** Lo que el carrito muestra arriba al llegar desde un pedido anterior. */
export interface DesdePedido {
  desde: string;
}

export function useVolverAPedir() {
  const navegar = useNavigate();
  const hayAlgo = useCarrito((s) => s.carrito.lineas.length > 0);
  const [pendiente, setPendiente] = useState<{ items: ItemRepetir[]; desde: string } | null>(null);

  const cargar = (items: ItemRepetir[], desde: string, modo: 'sumar' | 'reemplazar') => {
    cambiarCarrito((c) =>
      modo === 'reemplazar'
        ? cargarVarios({ ...carritoVacio(), opciones: c.opciones }, items)
        : cargarVarios(c, items, 'sumar'),
    );
    setPendiente(null);
    navegar('/carrito', { state: { desde } satisfies DesdePedido });
  };

  const pedir = (items: ItemRepetir[], desde: string) => {
    if (!items.length) return;
    if (hayAlgo) setPendiente({ items, desde });
    else cargar(items, desde, 'reemplazar');
  };

  const hoja = (
    <HojaInferior abierta={!!pendiente} onCerrar={() => setPendiente(null)} titulo="Ya tenés cosas en el pedido">
      <p className="text-[17px] text-stone-700">
        ¿Sumamos lo de {pendiente?.desde ?? 'ese pedido'} a lo que ya elegiste, o empezás un pedido nuevo con eso solo?
      </p>
      <div className="mt-5 flex flex-col gap-3">
        <Boton
          bloque
          tamano="lg"
          icono="add_shopping_cart"
          onClick={() => pendiente && cargar(pendiente.items, pendiente.desde, 'sumar')}
        >
          Sumar a lo que tengo
        </Boton>
        <Boton
          bloque
          tamano="lg"
          variante="secundario"
          icono="restart_alt"
          onClick={() => pendiente && cargar(pendiente.items, pendiente.desde, 'reemplazar')}
        >
          Empezar de nuevo con eso
        </Boton>
      </div>
    </HojaInferior>
  );

  return { pedir, hoja };
}
